import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getStudentDashboardDataService } from "@/service/dashboard.service";
import { StudentDashboardData } from "@/types/student-dashboard.model";
import { RootState } from "../index";

interface StudentDashboardState {
  data: StudentDashboardData | null;
  loading: boolean;
  error: string | null;
}

const initialState: StudentDashboardState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchStudentDashboardData = createAsyncThunk(
  "studentDashboard/fetchData",
  async () => {
    const response = await getStudentDashboardDataService();
    return response.data.data;
  }
);

const studentDashboardSlice = createSlice({
  name: "studentDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchStudentDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch student dashboard data";
      });
  },
});

// Selectors
export const selectStudentDashboardData = (state: RootState) => state.studentDashboard.data;
export const selectStudentDashboardLoading = (state: RootState) => state.studentDashboard.loading;
export const selectStudentDashboardError = (state: RootState) => state.studentDashboard.error;

export default studentDashboardSlice.reducer;
